import React from 'react'
import Menu from '@mui/material/Menu'
import styled from 'styled-components'

import { color } from 'styles/colors'

type Props = {
  companyName: string,
  name: string,
  email: string | null,
  phone: string,
  address: string,
  city: string
}

const CustomerInfo = ({ companyName, name, email, phone, address, city }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <S.Button
        onClick={e => setAnchorEl(e.currentTarget)}
        aria-controls={open ? 'customer-info' : undefined}
        aria-haspopup
        aria-label="customer-info"
      >
        <S.CaretIcon className={`icon-arrow-${anchorEl ? 'up' : 'down2'}`} />
      </S.Button>
      <Menu
        id="customer-info"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
      >
        <S.MenuItem>
          { email || phone || companyName || address || city
            ? (
              <div>
                <div>
                  <S.Email href={`mailto:${email}`} target="_blank" rel="noreferrer">{email}</S.Email >
                  <S.Phone href={`tel:${phone}`} target="_blank" rel="noreferrer">{phone}</S.Phone>
                </div>
                <S.Address>
                  {name !== companyName && <div>{companyName}</div>}
                  <div>{address}</div>
                  <div>{city}</div>
                </S.Address>
              </div>
            )
            : <div> No Customer Data </div>
          }
        </S.MenuItem>
      </Menu>
    </>
  )
}

export default CustomerInfo

const S = {
  Button: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${color('customerNameText')};
    font-weight: bold;
    outline: none;
    margin-right: 10px;
  `,
  CaretIcon: styled.i`
    font-size: 24px;
    position: relative;
    cursor: pointer;
  `,
  MenuItem: styled.li`
    padding: 15px;
    color: ${color('tooltipText')};

    &:first-child {
      margin-top: -8px;
    }
  `,
  Email: styled.a`
    display: block;
    text-decoration: underline;
  `,
  Phone: styled.a`
    display: block;
    color: ${color('tooltipText')};
  `,
  Address: styled.div`
    padding-top: 15px;
  `
}
